import aliasedEnzymesByName from "./aliasedEnzymesByName";
const defaultEnzymes = [
  "AanI",
  "AarI",
  "AatII",
  "AauI",
  "AbsI",
  "Acc16I",
  "Acc36I",
  "Acc65I",
  "AccB1I",
  "AccB7I",
  "AccBSI",
  "AccEBI",
  "AccI",
  "AccII",
  "AccIII",
  "AciI",
  "AclI",
  "AclWI",
  "AcoI",
  "AcsI",
  "AcuI",
  "AcvI",
  "AcyI",
  "AdeI",
  "AfaI",
  "AfeI",
  "AfiI",
  "AflII",
  "AflIII",
  "AgeI",
  "AgsI",
  "AhdI",
  "AhlI",
  "AjiI",
  "AjnI",
  "AjuI",
  "AleI",
  "AlfI",
  "AloI",
  "AluBI",
  "AluI",
  "Alw21I",
  "Alw26I",
  "Alw44I",
  "AlwI",
  "AlwNI",
  "Ama87I",
  "Aor13HI",
  "Aor51HI",
  "AoxI",
  "ApaI",
  "ApaLI",
  "ApeKI",
  "ApoI",
  "ArsI",
  "AscI",
  "AseI",
  "AsiGI",
  "AsiSI",
  "Asp35HI",
  "Asp713I",
  "AspA2I",
  "AspEI",
  "AspLEI",
  "AspMI",
  "AspS9I",
  "AsuC2I",
  "AsuHPI",
  "AsuII",
  "AsuNHI",
  "AtsI",
  "Atu1I",
  "Atu1II",
  "AvaI",
  "AvaII",
  "AviII",
  "AvrBI",
  "AvrII",
  "AxyI",
  "BaeGI",
  "BaeI",
  "BalI",
  "BamHI",
  "BanI",
  "BanII",
  "BarI",
  "BauI",
  "BbrPI",
  "BbsI",
  "BbuI",
  "Bbv12I",
  "BbvBI",
  "BbvCI",
  "BbvI",
  "BccI",
  "BceAI",
  "BcgI",
  "BciVI",
  "BclI",
  "BcnI",
  "BcoDI",
  "BcoKI",
  "BcuI",
  "BdiI",
  "BfaI",
  "BfmI",
  "BfuAI",
  "BfuI",
  "BglI",
  "BglII",
  "BlnI",
  "BlpI",
  "BlsI",
  "BmcAI",
  "Bme1390I",
  "Bme18I",
  "Bme216I",
  "BmeRI",
  "BmeT110I",
  "BmgBI",
  "BmgT120I",
  "BmiI",
  "BmrFI",
  "BmrI",
  "BmtI",
  "BmuI",
  "BmyI",
  "BnaI",
  "BoxI",
  "BpiI",
  "BplI",
  "BpmI",
  "Bpu10I",
  "Bpu1102I",
  "Bpu14I",
  "BpuAI",
  "BpuB5I",
  "BpuEI",
  "BpuMI",
  "Bsa29I",
  "BsaAI",
  "BsaBI",
  "BsaHI",
  "BsaI",
  "BsaJI",
  "BsaMI",
  "BsaVI",
  "BsaWI",
  "BsaXI",
  "Bsc4I",
  "Bse118I",
  "Bse1I",
  "Bse21I",
  "Bse3DI",
  "Bse8I",
  "BseAI",
  "BseBI",
  "BseCI",
  "BseDI",
  "BseGI",
  "BseJI",
  "BseLI",
  "BseMI",
  "BseMII",
  "BseNI",
  "BsePI",
  "BseRI",
  "BseSI",
  "BseX3I",
  "BseXI",
  "BseYI",
  "BsgI",
  "Bsh1236I",
  "Bsh1285I",
  "BshFI",
  "BshHI",
  "BshNI",
  "BshTI",
  "BshVI",
  "BsiEI",
  "BsiHKAI",
  "BsiHKCI",
  "BsiSI",
  "BsiWI",
  "BslFI",
  "BslI",
  "BsmAI",
  "BsmBI",
  "BsmFI",
  "BsmI",
  "BsnI",
  "Bso31I",
  "BsoBI",
  "BsoFI",
  "Bsp105I",
  "Bsp119I",
  "Bsp120I",
  "Bsp1286I",
  "Bsp139I",
  "Bsp13I",
  "Bsp1407I",
  "Bsp143I",
  "Bsp1720I",
  "Bsp19I",
  "Bsp4009I",
  "Bsp68I",
  "Bsp70I",
  "Bsp71I",
  "BspA2I",
  "BspACI",
  "BspCI",
  "BspCNI",
  "BspDI",
  "BspEI",
  "BspFNI",
  "BspHI",
  "BspLI",
  "BspMI",
  "BspOI",
  "BspPI",
  "BspQI",
  "BspT104I",
  "BspT107I",
  "BspTI",
  "BsrBI",
  "BsrDI",
  "BsrFI",
  "BsrGI",
  "BsrI",
  "BsrSI",
  "BssAI",
  "BssECI",
  "BssHII",
  "BssMI",
  "BssNAI",
  "BssNI",
  "BssSI",
  "BssT1I",
  "Bst1107I",
  "Bst2BI",
  "Bst2UI",
  "Bst4CI",
  "Bst6I",
  "Bst98I",
  "BstACI",
  "BstAFI",
  "BstAPI",
  "BstAUI",
  "BstB7SI",
  "BstBAI",
  "BstBI",
  "BstC8I",
  "BstDEI",
  "BstDSI",
  "BstEII",
  "BstENI",
  "BstF5I",
  "BstFI",
  "BstFNI",
  "BstH2I",
  "BstHHI",
  "BstHI",
  "BstIZ316I",
  "BstKTI",
  "BstLI",
  "BstMAI",
  "BstMBI",
  "BstMCI",
  "BstMWI",
  "BstNI",
  "BstNSI",
  "BstOI",
  "BstPAI",
  "BstPI",
  "BstRI",
  "BstSCI",
  "BstSFI",
  "BstSLI",
  "BstSNI",
  "BstUI",
  "BstV1I",
  "BstV2I",
  "BstX2I",
  "BstXI",
  "BstYI",
  "BstZ17I",
  "BstZI",
  "Bsu1532I",
  "Bsu15I",
  "Bsu36I",
  "Bsu8565I",
  "Bsu90I",
  "BsuI",
  "BsuRI",
  "BtgAI",
  "BtgI",
  "BtgZI",
  "BtrI",
  "BtsCI",
  "BtsI",
  "BtsIMutI",
  "BtuMI",
  "BveI",
  "Cac8I",
  "CaiI",
  "CciI",
  "CciNI",
  "CcoP95I",
  "CelII",
  "CeqI",
  "CfoI",
  "Cfr10I",
  "Cfr13I",
  "Cfr42I",
  "Cfr45I",
  "Cfr47I",
  "Cfr6I",
  "Cfr9I",
  "CjuII",
  "ClaI",
  "CpaAI",
  "CpoI",
  "CseI",
  "Csp45I",
  "Csp6I",
  "CspAI",
  "CspCI",
  "CspI",
  "CviJI",
  "CviKI-1",
  "CviQI",
  "DdeI",
  "DinI",
  "DpnI",
  "DpnII",
  "DraI",
  "DraIII",
  "DrdI",
  "DriI",
  "DsaI",
  "DsaVI",
  "DseDI",
  "EaeI",
  "EagI",
  "Eam1104I",
  "Eam1105I",
  "EarI",
  "EciDI",
  "EciI",
  "Ecl136II",
  "Ecl37I",
  "EclHKI",
  "Eco105I",
  "Eco130I",
  "Eco147I",
  "Eco211I",
  "Eco240I",
  "Eco241I",
  "Eco246I",
  "Eco247I",
  "Eco24I",
  "Eco31I",
  "Eco32I",
  "Eco47I",
  "Eco47III",
  "Eco52I",
  "Eco53kI",
  "Eco57I",
  "Eco68I",
  "Eco72I",
  "Eco81I",
  "Eco88I",
  "Eco91I",
  "Eco93I",
  "EcoICRI",
  "EcoNI",
  "EcoO109I",
  "EcoO65I",
  "EcoP15I",
  "EcoPI",
  "EcoRI",
  "EcoRII",
  "EcoRV",
  "EcoT14I",
  "EcoT22I",
  "EcoT38I",
  "EcoVIII",
  "EcoprrI",
  "EgeI",
  "EheI",
  "ErhI",
  "Esp3I",
  "EspHK22I",
  "FaeI",
  "FaiI",
  "FalI",
  "FaqI",
  "FatI",
  "FauI",
  "FauNDI",
  "FbaI",
  "FblI",
  "FdiII",
  "Fnu4HI",
  "FokI",
  "FriOI",
  "FseI",
  "Fsp4HI",
  "FspAI",
  "FspBI",
  "FspI",
  "GlaI",
  "GluI",
  "GsaI",
  "GsuI",
  "HaeII",
  "HaeIII",
  "HapII",
  "HgaI",
  "HgiAI",
  "HgiBI",
  "HhaI",
  "Hin1I",
  "Hin1II",
  "Hin6I",
  "HinP1I",
  "HincII",
  "HindII",
  "HindIII",
  "HinfI",
  "HpaI",
  "HpaII",
  "HphI",
  "Hpy166II",
  "Hpy188I",
  "Hpy188III",
  "Hpy8I",
  "Hpy99I",
  "HpyAV",
  "HpyCH4III",
  "HpyCH4IV",
  "HpyCH4V",
  "HpyF10VI",
  "HpyF13III",
  "HpyF19II",
  "HpyF21I",
  "HpyF28I",
  "HpyF29I",
  "HpyF36I",
  "HpyF3I",
  "HpyF62I",
  "HpyF65I",
  "HpyII",
  "HpySE526I",
  "Hsp92I",
  "Hsp92II",
  "HspAI",
  "I-CeuI",
  "I-SceI",
  "KasI",
  "KoyI",
  "Kpn2I",
  "KpnI",
  "KroI",
  "KroNI",
  "Ksp22I",
  "KspAI",
  "KspI",
  "Kzo9I",
  "LguI",
  "LmnI",
  "Lsp1109I",
  "LweI",
  "M.Bbu297I",
  "M.PmuDam",
  "MabI",
  "MaeK81I",
  "MalI",
  "MamI",
  "MauBI",
  "MbiI",
  "MboI",
  "MboII",
  "MfeI",
  "MflI",
  "MhlI",
  "MizI",
  "MlsI",
  "MluCI",
  "MluI",
  "Mly113I",
  "MlyI",
  "MmeI",
  "MnlI",
  "Mox20I",
  "Mph1103I",
  "Mph1103II",
  "MreI",
  "MroI",
  "MroNI",
  "MroXI",
  "MscI",
  "MseI",
  "MsiI",
  "MslI",
  "Msp20I",
  "MspA1I",
  "MspCI",
  "MspI",
  "MspJI",
  "MspR9I",
  "MssI",
  "MteI",
  "MthAI",
  "MunI",
  "Mva1269I",
  "MvaI",
  "MwoI",
  "NaeI",
  "NarI",
  "NciI",
  "NcoI",
  "NdaI",
  "NdeI",
  "NdeII",
  "NflAII",
  "NgbI",
  "NgoBVIII",
  "NgoDVIII",
  "NgoEII",
  "NgoMIV",
  "NgoTII",
  "NheI",
  "NlaIII",
  "NlaIV",
  "NmeAIII",
  "NmuCI",
  "NocI",
  "NotI",
  "NovII",
  "NruI",
  "NsbI",
  "NsiCI",
  "NsiI",
  "Nsp29132I",
  "NspI",
  "NspV",
  "OliI",
  "PacI",
  "Pae17kI",
  "PaeI",
  "PaeR7I",
  "PagI",
  "PalAI",
  "PaqCI",
  "PasI",
  "PauI",
  "Pca17AI",
  "PceI",
  "PciI",
  "PciSI",
  "PcsI",
  "PctI",
  "PdiI",
  "PdmI",
  "PecI",
  "PfaAIII",
  "PfeI",
  "Pfl16I",
  "Pfl23II",
  "PflFI",
  "PflMI",
  "PfoI",
  "PinAI",
  "PkrI",
  "Ple19I",
  "Ple214I",
  "PleI",
  "PluTI",
  "PmaCI",
  "PmeI",
  "PmlI",
  "PpsI",
  "Ppu21I",
  "PpuMI",
  "Pru2I",
  "Psb9879I",
  "PscI",
  "Pse31I",
  "PshAI",
  "PshBI",
  "PsiI",
  "Psp124BI",
  "Psp1406I",
  "Psp31I",
  "Psp33I",
  "Psp5I",
  "Psp5II",
  "Psp6I",
  "PspCI",
  "PspEI",
  "PspGI",
  "PspLI",
  "PspN4I",
  "PspOMI",
  "PspPI",
  "PspPPI",
  "PspXI",
  "PsrI",
  "PstI",
  "PstNI",
  "PsuI",
  "PsuNI",
  "PsyI",
  "PvuI",
  "PvuII",
  "Ral8I",
  "RgaI",
  "RigI",
  "RsaI",
  "RsaNI",
  "RseI",
  "RspLKI",
  "Rsr2I",
  "RsrII",
  "SacI",
  "SacII",
  "SalI",
  "SanDI",
  "SapI",
  "SatI",
  "Sau3AI",
  "Sau96I",
  "SauNI",
  "SbaI",
  "SbfI",
  "ScaI",
  "SchI",
  "ScrFI",
  "SdaI",
  "SduI",
  "SetI",
  "SexAI",
  "SfaAI",
  "SfaNI",
  "SfcI",
  "SfiI",
  "SflHK115731I",
  "SfoI",
  "Sfr274I",
  "Sfr303I",
  "SfuI",
  "SgeI",
  "SgfI",
  "SgrAI",
  "SgrBI",
  "SgrDI",
  "SgsI",
  "SinI",
  "SlaI",
  "Slu1777I",
  "SmaI",
  "SmiI",
  "SmiMI",
  "SmlI",
  "SmoI",
  "SnaBI",
  "SpeI",
  "SphI",
  "SrfI",
  "Srl61DI",
  "Sse8387I",
  "Sse9I",
  "SseBI",
  "SsiI",
  "Ssp2I",
  "SspDI",
  "SspI",
  "SspMI",
  "SstI",
  "StuI",
  "StyD4I",
  "StyI",
  "SuiI",
  "SwaI",
  "TaaI",
  "TaiI",
  "TaqI",
  "TaqII",
  "TasI",
  "TatI",
  "TauI",
  "TauII",
  "TfiI",
  "Tru1I",
  "Tru9I",
  "TscAI",
  "TscI",
  "TseFI",
  "TseI",
  "Tsp45I",
  "TspDTI",
  "TspGWI",
  "TspMI",
  "TspRI",
  "Tth111I",
  "TthHB8I",
  "Uba1093I",
  "Uba1095I",
  "Uba1122I",
  "Uba1160I",
  "Uba1229I",
  "Uba1371I",
  "Uba1380I",
  "Uba1403I",
  "Uba1415I",
  "Uba1437I",
  "Uba1439I",
  "Uba1440I",
  "Uba36I",
  "Uba41I",
  "Uba42I",
  "Uba89I",
  "UbaN13I",
  "Van91I",
  "VchO66I",
  "Vha464I",
  "VneI",
  "VpaK11BI",
  "VpaKutJI",
  "VspI",
  "XagI",
  "XapI",
  "XbaI",
  "XceI",
  "XcmI",
  "XcyI",
  "XhoI",
  "XhoII",
  "XmaCI",
  "XmaI",
  "XmaJI",
  "XmiI",
  "XmlI",
  "XmnI",
  "XphI",
  "XspI",
  "ZraI",
  "ZrmI",
  "Zsp2I"
];
const defaultEnzymesByName = {};
defaultEnzymes.forEach((name) => {
  const lookupName = name.toLowerCase().replace(/-/g, "");
  defaultEnzymesByName[name] = aliasedEnzymesByName[lookupName];
});
export default defaultEnzymesByName;
